export enum PaymentType {
  OneOffPayment = "OneOffPayment",
  RecurringPayment = "RecurringPayment",
  PaymentOnAccount = "PaymentOnAccount",
  Free = "Free",
}
